'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BASEURLPARAMGROUP = [["latitude", "longitude", "geotype"], // dp
["lat", "lng", "geotype"] // mt
];

var URL = function () {
    function URL() {
        _classCallCheck(this, URL);

        this.type = 'url';
        this.keeper = undefined;
        this.allowdCoordtype = ['wgs84', 'gcj02'];
    }

    _createClass(URL, [{
        key: 'initData',
        value: function initData() {
            this.query = location.search;
            this.urlParamGroup = [_config2.default.get('urlParamNames')].concat(BASEURLPARAMGROUP); // 自定义参数优先级高
        }
    }, {
        key: 'syncProcess',
        value: function syncProcess() {
            this.initData();
            return this.match(this.query, this.urlParamGroup);
        }
    }, {
        key: 'process',
        value: function process(succ, fail, next) {
            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 预处理
            typeof succ == 'function' || (succ = this.noop);
            typeof fail == 'function' || (fail = this.noop);
            typeof next == 'function' || (next = this.noop);

            try {
                this.initData();
                var position = this.match(this.query, this.urlParamGroup);
                if (!position) return next(); // 不匹配
                succ(_extends({ type: this.type }, position), opt.token);
            } catch (e) {
                fail({
                    code: 400,
                    message: e && e.message || JSON.stringify(e),
                    type: this.type
                }, opt.token);
            }
        }
    }, {
        key: 'match',
        value: function match(query, matchGroup) {
            var result = void 0;
            if (!query || !matchGroup) return result;
            for (var i = 0; i < matchGroup.length; i++) {
                if (!matchGroup[i].length) continue;
                if (!matchGroup[i][0] || !matchGroup[i][1]) continue;
                var latReg = new RegExp('[?&]' + matchGroup[i][0] + '=([^$&]+)'),
                    lngReg = new RegExp('[?&]' + matchGroup[i][1] + '=([^$&]+)'),
                    coordtypeReg = new RegExp('[?&]' + (matchGroup[i][2] || 'geotype') + '=([^$&]+)');
                var latMatch = query.match(latReg),
                    lngMatch = query.match(lngReg),
                    coordtypeMatch = query.match(coordtypeReg);
                if (latMatch && lngMatch && !isNaN(latMatch[1]) && !isNaN(lngMatch[1])) {
                    result = {
                        lat: latMatch[1],
                        lng: lngMatch[1]
                    };
                    if (coordtypeMatch && ~this.allowdCoordtype.indexOf(coordtypeMatch[1])) {
                        // url自定义经纬度、坐标系
                        result.geoType = coordtypeMatch[1];
                    } else if (/(dp\/com\.dianping)|(meituan)/.test(navigator.userAgent)) {
                        // app 注入经纬度，默认坐标系
                        result.geoType = /meituan/.test(navigator.userAgent) ? 'gcj02' : 'wgs84';
                    }
                    break;
                }
            }
            return result;
        }
    }, {
        key: 'noop',
        value: function noop() {}
    }]);

    return URL;
}();

var instance = new URL();
module.exports = instance.process.bind(instance);
module.exports.syncAPI = instance.syncProcess.bind(instance);
module.exports.type = instance.type;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/geos/url.js
// module id = 6
// module chunks = 0